/**
 * Hardware back-button capability (src/platform/).
 *
 * Contract: every capability has a working web implementation; native
 * branches (via the platform detection) MUST keep the web fallback. Web and
 * iOS are a complete no-op — the hardware back button only exists on Android,
 * where without a listener the default action backgrounds the whole app
 * instead of navigating SPA history. This seam pops react-router history when
 * there is somewhere to go back to, and exits the app at a root route
 * (standard Android behavior). @capacitor/app is loaded dynamically so no
 * Capacitor code enters the web bundle.
 */

import { getPlatform } from './detection'

/** Wire the Android hardware back button to SPA history; no-op elsewhere. */
export function initBackButton(): void {
  if (getPlatform() !== 'android') return
  void import('@capacitor/app')
    .then(({ App }) => {
      void App.addListener('backButton', ({ canGoBack }) => {
        // canGoBack reflects the WebView history, which includes react-router
        // pushState navigations. Pop history (BrowserRouter reacts to the
        // popstate) when possible, otherwise background/exit like a native app.
        if (canGoBack) {
          window.history.back()
        } else {
          void App.exitApp()
        }
      })
    })
    .catch(() => undefined)
}
